<template>
	<header id="header">
			<div class="headerWrap fixedLeft">
				<div class="headerTop">
					<dl>
						<dt>오늘의 환율</dt>
						<dd>$1={{usd}}</dd>
					</dl>
					<ul v-show="lginChk">
						<li><a @click="logout()"><span>로그아웃</span></a></li>
					</ul>
					<ul v-show="!lginChk">
						<li><router-link to="/"><span>로그인</span></router-link></li>
						<li><router-link to="/mbrChk"><span>회원가입</span></router-link></li>
					</ul>
				</div>
				<div class="headerBox">
					<h1 class="logo"><a href="#"><span class="hide">meritz 메리츠화재</span></a></h1>
					<nav class="gnbHeader">
						<ul class="dep1">
							<li class="active">
								<p>적하보험</p>
								<div class="dep2">
									<ul>
										<li><router-link to="/insurEstForm"><span>보험료견적</span></router-link></li>
										<li><router-link to="/insursumCargoidm"><span>상품안내</span></router-link></li>
										<li><router-link to="/contactpoint"><span></span>알아두실 사항</router-link></li>
										<li v-show="meunChk"><router-link to="/mbrinfo"><span>회원정보</span></router-link></li>
									</ul>
									<p>계약</p>
									<ul>
										
										<li v-show="meunChk == 'C' && viewChk == 2"><router-link to="/sbcpInpInqNdPolOtpt"><span>청약입력/조회 및 증권출력</span></router-link></li>
										<li v-show="meunChk == 'C'"><router-link to="/subsChangeForm"><span>증권 간략 정정</span></router-link></li>
										<li v-show="meunChk == 'C'"><router-link to="/unpaidList"><span>미납조회</span></router-link></li>
										<li v-show="meunChk == 'C'"><router-link to="/staMon"><span>계약통계</span></router-link></li>
										<li v-show="meunChk == 'C'"><router-link to="/getPolList"><span>계약조회</span></router-link></li>

									</ul>
									<p v-show="meunChk == 'A'"><router-link to="/admMgr">관리자용 메뉴</router-link></p>
									
								</div>
							</li>
							<li>
								<p>운송보험</p>
								<div class="dep2">
									<ul>
										<li><router-link to="/insursumTrs"><span>운송보험의 개요</span></router-link></li>
										<li><router-link to="/clmlossTrs"><span>보상내용</span></router-link></li>
										<li><router-link to="/traninsurepoint"><span>알아두실 사항</span></router-link></li>
									</ul>
								</div>
							</li>
							<li>
								<p>해상배상책임보험</p>
								<div class="dep2">
									<ul>
										<li><router-link to="/marinensursumCargoidm"><span>해상배상책임보험의 개요</span></router-link></li>
										<li><router-link to="/prodintroCargoidm"><span>판매상품소개</span></router-link></li>
										<li><router-link to="/cginsurepoint"><span>알아두실 사항</span></router-link></li>
									</ul>
								</div>
							</li>
							<li>
								<p>자료실</p>
								<div class="dep2">
									<ul>
										<li><router-link to="/noticeBd"><span>공지사항</span></router-link></li>
										<li><router-link to="/precData"><span>약관 및 판례</span></router-link></li>
										<li><router-link to="/docdownData"><span>주요서식</span></router-link></li>
									</ul>
								</div>
							</li>
						
						</ul>
					</nav>
					<div class="btnSiteMap">
						<a><span class="hide">사이트맵</span></a>
					</div>
					<div class="siteMap" id="siteMap" style="display: none;">
						<nav class="gnbSite">
							<ul class="dep1">
								<li class="active">
									<p><a href="#">적하보험</a></p>
									<ul class="dep2">
										<li><router-link to="/insurEstForm"><span>보험료견적</span></router-link></li>
										<li>
											<a href="#"><span>계약</span></a>
											<ul class="dep3">
												<li><router-link to="/contactpoint"><span>입력전 알아야 할 사항</span></router-link></li>
												<li v-show="meunChk == 'C' && viewChk == 2"><router-link to="/sbcpInpInqNdPolOtpt"><span>청약입력/조회 및 증권출력</span></router-link></li>
												<li v-show="meunChk == 'C'"><router-link to="/subsChangeForm"><span>증권 간략 정정</span></router-link></li>
												<li v-show="meunChk == 'C'"><router-link to="/unpaidList"><span>미납조회</span></router-link></li>
												<li v-show="meunChk == 'C'"><router-link to="/staMon"><span>계약통계</span></router-link></li>
											</ul>
										</li>
										<li>
											<a href="#"><span>상품안내</span></a>
											<ul class="dep3">
												<li><router-link to="/insursumCargoidm"><span>적하보험의 개요</span></router-link></li>
												<li><router-link to="/cargotarProdguid"><span>적하보험의 가입대상</span></router-link></li>
												<li><router-link to="/condcovProdguid"><span>조건별 담보안내</span></router-link></li>
												<li><router-link to="/insurstrtProdguid"><span>보험의 개시와 종료</span></router-link></li>
												<li><router-link to="/premcalProdguid"><span>보험료 산출 및 납입</span></router-link></li>
												<li><router-link to="/blaninsurProdguid"><span>포괄보험 안내</span></router-link></li>
											</ul>
										</li>
										<li v-show="meunChk"><router-link to="/mbrinfo"><span>회원정보</span></router-link></li>
									</ul>
								</li>
								<li>
									<p><a href="#">운송보험</a></p>
									<ul class="dep2">
										<li><router-link to="/insursumTrs"><span>운송보험의 개요</span></router-link></li>
										<li><router-link to="/clmlossTrs"><span>보상하는 손해</span></router-link></li>
										<li><router-link to="/traninsurepoint"><span>알아두실 사항</span></router-link></li>
									</ul>
								</li>
								<li>
									<p><a href="#">해상배상책임보험</a></p>
									<ul class="dep2">			
										<li><router-link to="/marinensursumCargoidm"><span>해상배상책임보험의 개요</span></router-link></li>
										<li><router-link to="/prodintroCargoidm"><span>판매상품 소개</span></router-link></li>
										<li><router-link to="/cginsurepoint"><span>알아두실 사항</span></router-link></li>
									</ul>
								</li>
								<li>
									<p><a href="#">자료실</a></p>
									<ul class="dep2">			
										<li><router-link to="/noticeBd"><span>공지사항</span></router-link></li>
										<li><router-link to="/precData"><span>약관 및 판례</span></router-link></li>
										<li><router-link to="/docdownData"><span>주요서식</span></router-link></li>
									</ul>
								</li>
							</ul>
							<button type="button" class="btnClose"><span class="hide">닫기</span></button>
						</nav>
					</div>
				</div>
			</div>
		</header>
</template>

<script setup>

import { useRouter } from 'vue-router';
import { inject, onBeforeMount, reactive, ref, watch, onMounted, computed } from 'vue';
import util from '@/common/util';
import { sessionUserInfo, load } from '@/common/sessionFactory'
import { useStore } from 'vuex';
const axios = inject('axios');
const router = useRouter();
const lginChk = ref(false);
const meunChk = ref("");
const viewChk = ref("");

const move = (linkNm) => {
	router.push({ name: linkNm });
}
const store = useStore();

const state = reactive({
	exChange : {},
});

watch(()=> store.state.common.lginChk, (newVal, oldVal)=>{
	lginChk.value = newVal;
	if(!newVal){
		meunChk.value = "";
	}
});

watch(()=> store.state.common.lginAuth , (newVal, oldVal)=>{
	meunChk.value = newVal;
});

watch(()=> store.state.common.loginTypeCd , (newVal, oldVal)=>{
	viewChk.value = newVal;
});


const usd = computed(() => {return store.state.common.exChange.stdExrt})


const logout  = () => {
	axios.json('/logout.do', {}).then(function(result){
		if(result.data.state == "Y"){
			store.commit('common/chgLginChk', false);
			store.commit('common/lginAuthChk', "");
			load();
			router.push("/");
		}
	})
}

onBeforeMount(async () => {
	await load();
	if(!_.isEmpty(sessionUserInfo)){
		meunChk.value = sessionUserInfo?.userInfo?.ind_corp_typ_cd;
		viewChk.value = sessionUserInfo?.userInfo?.login_typ_cd;
		lginChk.value = true;
	}
	else{
		meunChk.value = '';
		viewChk.value = '';
		lginChk.value = false;
	}
})



</script>

<style scoped>
.title {
  position: absolute;
  right: 15px;
  top: 16px;
}
</style>